import "./../../styles/Account.css";

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";

import Container from "../../components/Layout/Container";

import Input, { onEnter } from "../../components/TextField/Input";
import { Checkbox } from "../../components/CheckboxRadio/Checkbox";
// import { RadioGroup } from '../../components/CheckboxRadio/Radio';
import { Button } from "../../components/Button/Button";

import { fetchGet, fetchLogin } from "../../hooks/fetch";
// import { fetchPost } from '../../hooks/fetch';
import { isBlankStr } from "../../hooks/useValidate";
// import { handleVerificationCode } from '../../hooks/useValidate';
import { openAlert } from "../../components/Modal/MsgBox";
import {
  getTokenPayload,
  getUserToken,
  setUserToken,
} from "../../hooks/useLogin";
// import { UserTypeOptions } from '../mypage/UserEnum';

export default function Login() {
  if (getUserToken() !== "" && getTokenPayload().id !== 0) {
    openAlert("이미 로그인했습니다.", () => {
      window.location.replace("/");
    });
  }

  const pageName = "로그인";
  // const [membershipType, setMembershipType] = useState('CRIS'); // 회원 종류
  const loginInfoDefault = {
    userId: "",
    password: "",
    // verificationCode: "",
    userType: "GENERAL",
  };

  const [loginInfo, setLoginInfo] = useState(loginInfoDefault);
  const [rememberId, setRememberId] = useState(false); // 아이디 저장
  const [cookies, setCookie, removeCookie] = useCookies(["savedId"]);

  const onChangeLoginInfo = (e) => {
    const { name, value } = e.target;

    setLoginInfo((prev) => ({
      // ...loginInfo,
      // [name]: name === "verificationCode" ? handleVerificationCode(value) : value
      ...prev,
      [name]: value,
    }));
  };

  // const selectMemberShipType = (e) => {
  // 	setLoginInfo({
  // 		...loginInfoDefault,
  // 		userType: e.target.value
  // 	});
  // 	setMembershipType(e.target.value);
  // }

  const onKeyDown = (e) => {
    onEnter(e, () => {
      // if(membershipType === 'CRIS') { submit(); }
      // else if(membershipType === 'GENERAL') { login(); }
      login();
    });
  };

  const validateInput = () => {
    if (isBlankStr(loginInfo.userId)) {
      openAlert("아이디가 입력되지 않았습니다.");
      return false;
    }
    if (isBlankStr(loginInfo.password)) {
      openAlert("비밀번호가 입력되지 않았습니다.");
      return false;
    }

    return true;
  };

  // function sendSmsVerifyCode() {
  // 	if(!validateInput()) return;

  // 	fetchPost(
  // 		"/smsVerification/send/login",
  // 		"인증번호를 전송",
  // 		{
  // 			userId: loginInfo.userId,
  // 			password: loginInfo.password,
  // 			userType: loginInfo.userType
  // 		}
  // 	)
  // }

  function getMyInfo() {
    fetchGet("/users/myinfo", (json) => {
      if (rememberId) {
        setCookie("savedId", loginInfo.userId, {
          path: "/",
          maxAge: 7 * 24 * 60 * 60,
        });
      } else {
        removeCookie("savedId", { path: "/" });
      }

      setUserToken(json);
      window.location.replace("/");
    });
  }

  function login() {
    // general
    if (!validateInput()) return;

    fetchLogin(
      {
        loginId: loginInfo.userId,
        password: loginInfo.password,
        userType: loginInfo.userType,
      },
      getMyInfo,
    );
  }

  // function submit() {	// cris
  // 	if(!validateInput()) return;
  // 	if(isBlankStr(loginInfo.verificationCode)) {
  // 		openAlert("인증번호를 입력해 주세요.");
  // 		return;
  // 	}

  // 	fetchPost(
  // 		"/smsVerification/check",
  // 		"인증에 성공",
  // 		loginInfo,
  // 		login
  // 	)
  // }

  // useEffect(() => {
  // 	if (cookies.savedId) {
  // 		setRememberId(true);
  // 		setLoginInfo({
  // 			...loginInfo,
  // 			userId: cookies.savedId
  // 		});
  // 	}
  // }, [membershipType]);

  useEffect(() => {
    if (cookies.savedId) {
      setRememberId(true);
      setLoginInfo((prev) => ({
        ...prev,
        userId: cookies.savedId,
      }));
    }
  }, []);

  return (
    <main id="account-page-wrap">
      <h1 className="sr-only">{`${pageName} 페이지`}</h1>

      <Container>
        <div className="page-content login-page">
          <div className="gs-account-form">
            <h1 className="top">{pageName}</h1>

            {/* <div>
							<RadioGroup
								id="membership-type-radio-buttons-group"
								itemClassName="round"
								name="rd_membership_type"
								ckeckOptions={UserTypeOptions}
								// checked={membershipType}
								// onChange={selectMemberShipType}
							/>
						</div> */}

            {/* {membershipType === 'CRIS'
							?
							<div>
								<Input.Group>
									<Input
										id="user-id"
										type="email"
										label="아이디(CRIS 사번)를 입력해주세요."
										placeholder="아이디(CRIS 사번) 입력"
										name="userId"
										value={loginInfo.userId}
										onChange={onChangeLoginInfo}
										onKeyDown={onKeyDown}
										maxLength={30}
									/>

									<Input.PasswordEye
										id="user-password"
										label="비밀번호(CRIS 비밀번호)를 입력해주세요."
										placeholder="비밀번호(CRIS 비밀번호) 입력"
										name="password"
										value={loginInfo.password}
										onChange={onChangeLoginInfo}
										maxLength={20}
										onKeyDown={onKeyDown}
									/>
									<div>
										<Button
											type="button"
											className="full fs-18 silver"
											onClick={sendSmsVerifyCode}
										>
											<strong>인증번호 요청</strong>
										</Button>
									</div>
									<Input
										id="authentication-num"
										type="tel"
										label="인증번호를 입력해주세요."
										placeholder="인증번호 입력"
										name="verificationCode"
										value={loginInfo.verificationCode}
										onChange={onChangeLoginInfo}
										onKeyDown={onKeyDown}
										maxLength={6}
									/>
								</Input.Group>
								<div className="bottom">
									<div>
										<Checkbox value="save-id" checked={rememberId} onChange={() => setRememberId(!rememberId)}>
											아이디 저장
										</Checkbox>
									</div>
								</div>
								<div className="gs-bottom-btns col">
									<Button
										className="submit"
										onClick={submit}
									>
										<strong>로그인</strong>
									</Button>

									<Link to="./../signup" className="gs-btn white">
										<strong>회원 가입</strong>
									</Link>
								</div>
								<div>
									<div>
										<Link to="./../reset/loginid" className="gs-underline-item blue">
											<div>
												<span className="line">아이디 변경</span>{' '}
												<span>(*사번이 변경된 분만 이용해 주세요.)</span>
											</div>
										</Link>
									</div>
								</div>
							</div>
							: */}
            <div>
              <Input.Group>
                <Input
                  id="user-id"
                  type="email"
                  label="아이디(이메일)를 입력해주세요."
                  placeholder="아이디(이메일) 입력"
                  name="userId"
                  value={loginInfo.userId}
                  onChange={onChangeLoginInfo}
                  onKeyDown={onKeyDown}
                  maxLength={30}
                />

                <Input.PasswordEye
                  id="user-password"
                  label="비밀번호를 입력해주세요."
                  placeholder="비밀번호 입력"
                  name="password"
                  value={loginInfo.password}
                  onChange={onChangeLoginInfo}
                  maxLength={20}
                  onKeyDown={onKeyDown}
                />
              </Input.Group>
              <div className="bottom">
                <div>
                  <Checkbox
                    value="save-id"
                    checked={rememberId}
                    onChange={() => setRememberId(!rememberId)}
                  >
                    아이디 저장
                  </Checkbox>
                </div>
                <div>
                  <Link to="./../find/loginid" className="gs-underline-item">
                    <span className="line">아이디 찾기</span>
                  </Link>
                  <Link to="./../find/password" className="gs-underline-item">
                    <span className="line">비밀번호 찾기</span>
                  </Link>
                </div>
              </div>
              <div className="gs-bottom-btns col">
                <Button className="submit" onClick={login}>
                  <strong>로그인</strong>
                </Button>

                <Link to="./../signup" className="gs-btn white">
                  <strong>회원 가입</strong>
                </Link>
              </div>
            </div>
            {/* } */}
          </div>
        </div>
      </Container>
    </main>
  );
}
